module.exports = __webpack_public_path__ + "files/938bedd3d78967de4155b751fe10d350.png";